const SliderData = [
    {
        image:'https://images.unsplash.com/photo-1517157837591-17b69085bfdc?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTAyfHxwYXN0ZWx8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        alt: 'pastel sugar buttons'
       
    },
    {
        image:'https://images.unsplash.com/photo-1490367605959-06955305859b?ixid=MnwxMjA3fDB8MHxzZWFyY2h8OTl8fHBhc3RlbHxlbnwwfHwwfHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        alt: 'green pink and yellow macarons on a pink background'
    },
    {
        image:'https://images.unsplash.com/photo-1529767367174-535729449d71?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDh8fHBhc3RlbCUyMGZvb2R8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        alt: 'colorful pastel sprinkles'
    },
    {
        image:'https://images.unsplash.com/photo-1519869491916-8ca6f615d6bd?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTR8fHBhc3RlbCUyMGZvb2R8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        alt: 'vanilla cupcakes with white frosting and pastel decorations'
    },
    {
        image:'https://images.unsplash.com/photo-1523992038393-d5ab874a077e?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTd8fHBhc3RlbCUyMGZvb2R8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        alt: 'two pale pink lollipops with a bow on a pink background'
    },
    {
        image:'https://cdn.pixabay.com/photo/2017/08/06/06/58/food-2589686__340.jpg',
        alt: 'a row of cupcakes with pale turquoise frosting and sprinkles'
       
    },
    {
        image:'https://images.unsplash.com/photo-1570476922354-81227cdbb76c?ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8c3dlZXRzfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        alt: 'three rows of assorted macarons in a white box'
    },
    {
        image:'https://images.unsplash.com/photo-1516747773440-e114ee0d3c07?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTV8fGNhbmRpZXN8ZW58MHx8MHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        alt: 'pastel-colored sour worm candies'
    },
    {
        image:'https://images.unsplash.com/photo-1541717872011-9d16b87a5551?ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTE4fHxjb29raWVzfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60',
        alt: 'cookies with colorful small round decorations on top'
    },
    {
        image:'https://images.unsplash.com/photo-1516919549054-e08258825f80?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjR8fHN3ZWV0c3xlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60',
        alt: 'six pastel donuts fading out of view'
    }
]

export default SliderData